import React from "react";
import { cn } from "src/lib/utils";

const TextArea = ({ label, name, placeholder, value, onChange, error, autoComplete, className }) => {
	return (
		<div className={cn("fullFormItem", className)}>
			<label htmlFor={name}>{label}</label>
			<textarea
				id={name}
				name={name}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				autoComplete={autoComplete}
				className={error ? "inputError" : ""}
			></textarea>
			{error && <p className="errorMsg">{error}</p>}
		</div>
	);
};

export default TextArea;
